import React, { useMemo, useState } from 'react';
import { Platform, View } from 'react-native';
import moment from 'moment';

import { Text } from '../../../components';
import PickerButton from '../../../components/picker/PickerButton/PickerButton';
import { useThemedStyles } from '../../../hooks/useThemedStyles';

let DateTimePickerModal;
if (Platform.OS === 'web') {
	DateTimePickerModal = require('../../../components/DateTimePickerModal.web').default;
} else {
	DateTimePickerModal = require('react-native-modal-datetime-picker').default;
}

const SetupDateField = ({
	label,
	value,
	onChange,
	required = false,
}) => {
	const styles = useThemedStyles(createStyles);
	const [open, setOpen] = useState(false);

	const formatted = useMemo(() => {
		return value ? moment(value).format('DD MMM YYYY') : 'Select date';
	}, [value]);

	return (
		<View style={styles.container}>
			<Text style={styles.label}>
				{label}
				{required && <Text style={styles.required}> *</Text>}
			</Text>
			{/* Same field look as the other selectors and date fields. */}
			<PickerButton onPress={() => setOpen(true)} accessibilityRole="button" accessibilityLabel={`${label}, ${formatted}`}>
				{formatted}
			</PickerButton>
			<DateTimePickerModal
				isVisible={open}
				mode="date"
				onConfirm={(selectedDate) => {
					setOpen(false);
					onChange(selectedDate);
				}}
				onCancel={() => setOpen(false)}
				date={value ? new Date(value) : new Date()}
			/>
		</View>
	);
};

const createStyles = ({ ui: { colors, type, space } }) => ({
	container: {
		marginTop: space.md,
		marginBottom: space.lg,
	},
	label: {
		...type.fieldLabel,
		color: colors.text,
		marginBottom: 6,
	},
	required: {
		color: colors.danger,
	},
});

export default SetupDateField;
